// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QfD4","rootNoMargin":"styles_rootNoMargin__3l1LA"};